import { Link } from "react-router-dom";
import { Container } from "../../components/layout/Container";
import { Card } from "../../components/ui/Card";
import { usePageTitle } from "../../lib/usePageTitle";
import styles from "../Prose.module.css";


export function PrivacyPage() {
  usePageTitle(
    "Политика конфиденциальности — Geobiom",
    "Какие данные Geobiom собирает, как и зачем хранит, и как их удалить.",
  );
  return (
    <Container as="article" size="narrow">
      <h1 className={styles.h1}>Политика конфиденциальности</h1>

      <Card>
        <p className={styles.p} style={{ margin: 0, color: "var(--ink-dim)" }}>
          Драфт от 3 мая 2026 года. Это не юридическая консультация
          и не готовый к аудиту документ — это честное описание того,
          какие данные сайт хранит и зачем. Формальное согласование под
          ФЗ-152 («О персональных данных») пока не проводилось; по мере
          того как проект перестанет быть хобби, документ будет
          дорабатываться.
        </p>
      </Card>

      <h2 className={styles.h2}>1. Кто оператор</h2>
      <p className={styles.p}>
        Проект Грибная карта делает физическое лицо — Иван Кочеров,
        как личный некоммерческий проект. Контакт для любых вопросов о
        данных:{" "}
        <a href="mailto:ikocherov@mail.ru">ikocherov@mail.ru</a>.
      </p>

      <h2 className={styles.h2}>2. Что мы собираем</h2>
      <p className={styles.p}>
        <strong>До входа в аккаунт.</strong> Пока вы не нажали «Войти»,
        сайт не собирает ничего, что можно связать с конкретным человеком.
        Нет Яндекс.Метрики, Google Analytics, Facebook Pixel или других
        трекеров. Серверные логи веб-сервера (FastAPI + Caddy) содержат
        временные IP-адреса и user-agent — они нужны для диагностики
        аварий, хранятся не дольше 14 дней и не связываются с
        аккаунтами.
      </p>
      <p className={styles.p}>
        <strong>После входа через Яндекс ID.</strong> Яндекс передаёт
        нам три поля: стабильный идентификатор пользователя, имя/ник для
        отображения и — если вы не сняли галочку на странице согласия —
        email и ссылку на аватар. Мы храним ровно эти поля плюс
        техническую метадату (дата регистрации, дата последнего входа,
        локаль).
      </p>
      <p className={styles.p}>
        <strong>Сессии.</strong> На устройстве ставится одна HttpOnly
        cookie (<code>mm_refresh</code>) со случайной строкой — она
        продлевает сессию без повторного OAuth-шага. На сервере
        хранится не сам токен, а его криптохэш, плюс user-agent и
        IP-адрес устройства, с которого сессия открыта (чтобы вы могли
        в будущем увидеть список «устройств, где я вошёл» и отозвать
        лишнее). Срок жизни сессии — 30 дней; каждое обращение к серверу
        продлевает и ротирует токен.
      </p>
      <p className={styles.p}>
        <strong>Контент кабинета.</strong> Если вы сохраняете места в
        веб-версии или мобильном приложении (координата, рейтинг 1–5,
        теги пород деревьев и видов грибов/ягод, текстовая заметка),
        эти записи хранятся у нас в базе и в обычном режиме видны
        только вам. В исходном виде — с привязкой к вашему аккаунту и
        точными координатами — точки не публикуются и не передаются
        третьим сторонам.
      </p>
      <p className={styles.p}>
        <strong>Обезличенные агрегаты точек.</strong> Мы оставляем за
        собой право использовать <em>обезличенные агрегаты</em> сохранённых
        мест — то есть статистику без привязки к конкретному пользователю
        и без точных координат отдельных точек — для следующих целей:
        построение статистики «хороших» грибных лесов (распределение по
        породам, возрасту древостоя, районам), обучение и валидация
        модели прогноза плодоношения, внутренние продуктовые решения о
        развитии сервиса. Минимальная гранулярность агрегации — район
        (admin_level=6) или ячейка геосетки; одиночные точки в открытый
        доступ не выгружаются.
      </p>

      <h2 className={styles.h2}>3. Что мы НЕ собираем</h2>
      <ul style={{ paddingLeft: "1.25rem", lineHeight: "var(--lh-long)", marginBottom: "var(--space-4)" }}>
        <li>Трекеры и cookies рекламных сетей.</li>
        <li>Пароли (OAuth — у вас пароля к нам просто нет).</li>
        <li>Биометрию или фоновую геолокацию устройства. Координата
          уходит на сервер только когда вы сами это инициируете —
          например, сохраняете место в кабинете или мобильном
          приложении (см. п. 2). Кнопка «показать моё положение» на
          карте обрабатывается в браузере/приложении и на сервер
          ничего не отправляет.</li>
        <li>Содержимое ваших фотографий, если вы не загрузили их в
          кабинет сознательно.</li>
      </ul>

      <h2 className={styles.h2}>4. Третьи стороны</h2>
      <p className={styles.p}>
        <strong>Яндекс ID</strong> — провайдер входа (OAuth 2.0).
        Политика Яндекса применяется к вашему взаимодействию с ним:{" "}
        <a
          href="https://yandex.ru/legal/confidential/"
          target="_blank"
          rel="noreferrer"
        >
          yandex.ru/legal/confidential
        </a>
        . Мы получаем от Яндекса только указанные выше поля и только
        если вы явно подтвердите согласие на их передачу в момент входа.
      </p>
      <p className={styles.p}>
        <strong>Хостинг.</strong> Основная инфраструктура — API, база
        данных, статические ресурсы и тайлы карт — размещена на
        виртуальной машине российского хостинг-провайдера TimeWeb
        (адрес <code>geobiom.ru</code>). Дополнительная зеркальная
        копия сервиса работает на виртуальной машине Oracle Cloud в
        Стокгольме (адрес <code>app.geobiom.ru</code>) — она нужна,
        чтобы сайт оставался доступен пользователям, у которых
        российский маршрут до основного сервера заблокирован. База
        зеркала синхронизируется с основной примерно раз в сутки, то
        есть содержит ту же информацию о пользователях с задержкой до
        24 часов.
      </p>
      <p className={styles.p}>
        <strong>Резервные копии.</strong> Раз в сутки база данных
        копируется в шифрованном виде (алгоритм <code>age</code>,
        приватный ключ есть только у автора проекта) в облачное
        хранилище Yandex Object Storage. Копии хранятся не более 90
        дней (7 ежедневных + 4 еженедельных + 3 ежемесячных) и
        используются только для восстановления после аварии.
      </p>
      <p className={styles.p}>
        <strong>Открытые картографические данные.</strong> Карта
        подгружает пиктограммы с серверов OpenFreeMap / Versatiles /
        ESRI — они видят запросы к тайлам, но не знают, кто вы.
      </p>

      <h2 className={styles.h2}>5. Срок хранения и удаление аккаунта</h2>
      <p className={styles.p}>
        Данные профиля хранятся пока у вас есть аккаунт. При удалении
        аккаунта стираются: профиль, все активные сессии, сохранённые
        места и заметки. Запись о факте удаления (идентификатор + дата)
        остаётся в статусе <code>deleted</code> для защиты от повторного
        бана/ухода. Срок хранения этой служебной записи — не больше 90
        дней, после чего она стирается физически.
      </p>
      <p className={styles.p}>
        <strong>Как удалить аккаунт прямо сейчас:</strong> кнопки в
        интерфейсе пока нет. Напишите на{" "}
        <a href="mailto:ikocherov@mail.ru">ikocherov@mail.ru</a>{" "}
        с указанием email вашего Яндекс-аккаунта — удаление ручное,
        в течение 7 дней. Подтверждение придёт письмом. Кнопка в
        кабинете появится в одной из ближайших фаз.
      </p>

      <h2 className={styles.h2}>6. Ваши права</h2>
      <p className={styles.p}>
        Вы вправе запросить копию данных, которые мы о вас храним,
        исправление неточностей или удаление. Все запросы — на тот же
        адрес{" "}
        <a href="mailto:ikocherov@mail.ru">ikocherov@mail.ru</a>.
        Отвечаем в течение 30 дней.
      </p>

      <h2 className={styles.h2}>7. Дети</h2>
      <p className={styles.p}>
        Сайт не ориентирован на детей младше 13 лет и не собирает их
        данные сознательно. Если вы родитель и обнаружили аккаунт
        ребёнка, напишите — удалим немедленно.
      </p>

      <h2 className={styles.h2}>8. Изменения</h2>
      <p className={styles.p}>
        Дата последнего обновления указана в шапке. Существенные
        изменения (например, появление новых источников данных или
        новых провайдеров входа) будут отражаться в комментарии к
        коммиту в{" "}
        <a
          href="https://github.com/yungkocherov/mushroom_map/commits/main"
          target="_blank"
          rel="noreferrer"
        >
          репозитории
        </a>
        .
      </p>

      <p className={styles.p} style={{ color: "var(--ink-dim)", fontSize: "var(--fs-sm)" }}>
        См. также:{" "}
        <Link to="/legal/terms">условия использования</Link>,{" "}
        <Link to="/about">о проекте</Link>.
      </p>
    </Container>
  );
}
